"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetExtendedContactDetailsAllOf {
    static getAttributeTypeMap() {
        return GetExtendedContactDetailsAllOf.attributeTypeMap;
    }
}
GetExtendedContactDetailsAllOf.discriminator = undefined;
GetExtendedContactDetailsAllOf.attributeTypeMap = [
    {
        "name": "statistics",
        "baseName": "statistics",
        "type": "GetExtendedContactDetailsAllOfStatistics"
    }
];
exports.GetExtendedContactDetailsAllOf = GetExtendedContactDetailsAllOf;
//# sourceMappingURL=getExtendedContactDetailsAllOf.js.map